<template>
  <div>
    <div class="px-4 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-20 md:px-28 lg:px-10" ref="tab">
      <ul class="flex flex-wrap justify-center">
        <!--        <li class="w-1/3 text-lg text-center text-gray-500 py-4 px-4 font-medium border-transparent cursor-pointer" v-for="(item, index) in tabs"-->
        <!--            :key="index" :class="{ active: active === index }" @click="switchTab(index)" >-->
        <!--          {{item}}-->
        <!--        </li>-->
        <li class="w-1/3 text-lg text-center text-gray-500 py-4 px-4 font-medium border-transparent cursor-pointer"
          :class="{ active: active === 0 }" @click="switchTab(0)">
          精彩直播
        </li>
        <li class="w-1/3 text-lg text-center text-gray-500 py-4 px-4 font-medium border-transparent cursor-pointer"
          :class="{ active: active === 2 }" @click="switchTab(2)">
          学位教育
        </li>


      </ul>
    </div>
    <div class="cont1" ref="cont">
      <div>
        <div
          class="px-4 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-20 md:px-28 lg:px-10 sm:py-24 lg:py-24 ">
          <div class="flex justify-center items-center">
            <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
            <p class="w-36 h-9 text-2xl text-center leading-9 text-lg font-bold tracking-widest text-gray-600">平台介绍</p>
            <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
          </div>

          <div class="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 mt-10">
            <div class="relative overflow-hidden shadow-md bg-white border-dashed border border-black">
              <img class="object-cover w-full contImg" :src="baseOSSUrl + '/introduce1.png'" alt="" />
              <div class="p-6 border-dashed border-t border-black">
                <p class="mb-2 text-sm tracking-wider text-gray-400">
                  EMHUB在线教育平台提供实时、互动的在线课堂教学。新冠疫情期间，平台帮助来自世界各地的学生和教师实现了实时的交流与互动。平台通过引入世界各高校的优质课程，分享海外多平台的优质课程资源，与全球学习者共同进步。
                </p>
              </div>
            </div>
            <div class="relative overflow-hidden shadow-md bg-white border-dashed border border-black">
              <img class="object-cover w-full contImg" :src="baseOSSUrl + '/introduce2.png'" alt="" />
              <div class="p-6 border-dashed border-t border-black">
                <p class="mb-2 text-sm tracking-wider text-gray-400">
                  通过社区的概念，促进各国学者在平台进行积极、无障碍的交流。学生通过加入平台上的多元化“社区”，鼓励并促进开展相互学习和小组讨论，有助于课前预习、课上沟通及课后复习，增加学习效率。
                </p>
              </div>
            </div>
            <div class="relative overflow-hidden shadow-md bg-white border-dashed border border-black">
              <img class="object-cover w-full contImg" :src="baseOSSUrl + '/introduce3.png'" alt="" />
              <div class="p-6 border-dashed border-t border-black">
                <p class="mb-2 text-sm tracking-wider text-gray-400">
                  线上教学在落实疫情防控的背景下提供了新的教学思路，推动了互联网时代的教育教学模式变革发展，线上教学成为了教育教学新常态。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="cont1" ref="cont_1">
        <div
          class="px-4 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-20 md:px-28 lg:px-10 sm:py-24 lg:py-24 ">
          <div class="flex justify-center items-center">
            <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
            <p class="w-36 h-9 text-2xl text-center leading-9 text-lg font-bold tracking-widest text-gray-600">精彩直播</p>
            <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
          </div>
          <div class="flex flex-wrap w-full flex-col items-center text-center mt-5">
            <p class="lg:w-3/4 w-full leading-relaxed text-gray-400 text-sm">
              EMHUB支持线上教育平台，提供以下线上培训
            </p>
          </div>
          <div class="grid gap-5 sm:grid-cols-1 lg:grid-cols-2 mt-10 max-w-screen-md mx-auto">
            <div
              class="relative overflow-hidden transition duration-300 transform shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl border-dashed border border-black">
              <img class="object-cover w-full " :src="baseOSSUrl + '/linchuang1.png'" alt="" />
              <div class="p-6">
                <p class=" mb-4 text-base font-bold leading-5 transition-colors duration-200 block text-center">
                  临床线上培训
                </p>
                <p class="text-sm tracking-wider text-gray-400 text-center">
                  由美国、西班牙、德国等国的医学专家提供临床在线培训 - EMHUB作为中国与欧美国家的医学纽带，邀请顶级专家介绍其各自领域的成功案例以及该领域的前沿理念与技术。
                </p>
              </div>
            </div>
            <div
              class="relative overflow-hidden transition duration-300 transform shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl border-dashed border border-black">
              <img class="object-cover w-full contImg" :src="baseOSSUrl + '/linchuang2.png'" alt="" />
              <div class="p-6">
                <p class=" mb-4 text-base font-bold leading-5 transition-colors duration-200 block text-center">
                  线上护理讲座
                </p>
                <p class="mb-2 text-sm tracking-wider text-gray-400 text-center">
                  德国海德堡F+U教育集团提供在线护理课程讲座 -
                  该集团凭借其几十年的护理职业教育背景，提供护理职业教育、职业再教育、护理证书认证教育等课程。除中国护理职业教育中的常规课程外，还提供德国在护理教育的前沿课程。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--      <div class="bg-white" ref="cont_2">-->
      <!--        <div class="px-4 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-20 md:px-28 lg:px-10 lg:py-24">-->
      <!--          <div class="flex justify-center items-center">-->
      <!--            <img :src="baseOSSUrl + '/news-1.png" alt="" class="h-5 w-5">-->
      <!--            <p class="w-36 h-9 text-2xl text-center leading-9 text-lg font-bold tracking-widest text-gray-600">认证教育</p>-->
      <!--            <img :src="baseOSSUrl + '/news-1.png" alt="" class="h-5 w-5">-->
      <!--          </div>-->
      <!--          <div class="flex flex-wrap w-full flex-col items-center text-center mt-5">-->
      <!--            <p class="lg:w-2/3 w-full leading-relaxed text-gray-400 text-sm">-->
      <!--              Emhub联合世界优秀教育集团和教育平台，提供证书类教育-->
      <!--            </p>-->
      <!--          </div>-->
      <!--          <div class="container cont2">-->
      <!--            <div class="container mx-auto my-10">-->
      <!--                <div class="flex flex-wrap md:flex-nowrap mx-36" style="height: 190px;">-->
      <!--                  <div class=" flex-shrink-0 flex flex-col " style="width: 17.5rem;">-->
      <!--                      <video-player-->
      <!--                          class="video-player vjs-custom-skin object-cover w-full"-->
      <!--                          ref="videoPlayer"-->
      <!--                          :playsinline="true"-->
      <!--                          :options="options"-->
      <!--                          @play="onPlayerPlay($event)"-->
      <!--                          @pause="onPlayerPause($event)"-->
      <!--                          @ended="onPlayerEnded($event)"-->
      <!--                          @waiting="onPlayerWaiting($event)"-->
      <!--                          @playing="onPlayerPlaying($event)"-->
      <!--                          @loadeddata="onPlayerLoadeddata($event)"-->
      <!--                          @timeupdate="onPlayerTimeupdate($event)"-->
      <!--                          @canplay="onPlayerCanplay($event)"-->
      <!--                          @canplaythrough="onPlayerCanplaythrough($event)"-->
      <!--                          @statechanged="playerStateChanged($event)"-->
      <!--                          @ready="playerReadied"-->
      <!--                      >-->
      <!--                      </video-player>-->
      <!--                  </div>-->
      <!--                  <div class="relative md:flex-grow">-->
      <!--                    <div class="h-full w-10 absolute inset-0 flex items-center justify-center mt-3">-->
      <!--                      <div class="h-full w-px bg-gray-200 pointer-events-none"></div>-->
      <!--                    </div>-->
      <!--                    <div class="mx-5 block item px-5">-->
      <!--                      <div class="font-medium text-lg mb-3" style="letter-spacing: 1px;color: #333333;">-->
      <!--                        由BauBildungSachen提供的-->
      <!--                      </div>-->
      <!--                      <div class="text-gray-400 text-sm tracking-wider newsIntroduceClass ">-->
      <!--                        其课程培训证书由课程提供方颁发，受到德国-->
      <!--                      </div>-->
      <!--                    </div>-->
      <!--                  </div>-->
      <!--                </div>-->

      <!--                <div class="flex flex-wrap md:flex-nowrap mx-36">-->
      <!--                  <div class="flex-shrink-0 flex flex-col item" style="width: 17.5rem;">-->
      <!--                    <img :src="baseOSSUrl + '/rz2.png" alt="">-->
      <!--                  </div>-->
      <!--                  <div class="relative md:flex-grow">-->
      <!--                    <div class="h-full w-10 absolute inset-0 flex items-center justify-center mt-3">-->
      <!--                      <div class="h-full w-px bg-gray-200 pointer-events-none mb-3"></div>-->
      <!--                    </div>-->
      <!--                    <div class="mx-5 block item px-5">-->
      <!--                      <div class="font-medium text-lg mb-3" style="letter-spacing: 1px;color: #333333;">-->
      <!--                        由BauBildungSachen提供的-->
      <!--                      </div>-->
      <!--                      <div class="text-gray-400 text-sm tracking-wider newsIntroduceClass">-->
      <!--                        其课程培训证书由课程提供方颁发，受到德国及欧盟认证-->
      <!--                      </div>-->
      <!--                    </div>-->
      <!--                  </div>-->
      <!--                </div>-->
      <!--            </div>-->

      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <div class="cont3" ref="cont_3">
        <div
          class="px-4 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-20 md:px-28 lg:px-10 sm:py-24 lg:py-24 ">
          <div class="flex justify-center items-center">
            <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
            <p class="w-36 h-9 text-2xl text-center leading-9 text-lg font-bold tracking-widest text-gray-600">学位教育</p>
            <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
          </div>
          <div class="flex flex-wrap w-full flex-col items-center text-center mt-5">
            <p class="lg:w-3/4 w-full leading-relaxed text-gray-400 text-sm">
              EMHUB 计划联合世界知名大学，在中国设立中外合作办学大学，有本科、硕士、博士学位的授予权，是一所包括医学院、大健康学院、工程学院、管理学院等在内的综合性大学。
            </p>
          </div>
          <div
            class="grid gap-4 mx-auto sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 py-10 justify-items-center text-center">
            <div class="relative shadow w-56 h-64 bg-white" style="border-radius: 1.25rem">
              <div class="px-4">
                <img :src="baseOSSUrl + '/xuewei1.png'" class="text-indigo-500 w-12 h-12 my-10 inline-block" alt="">
                <div class="text-black text-lg font-medium">人才教育</div>
                <div class="text-sm text-gray-400 mt-2 font-normal">以医学教育为切入点的国际化应用型人才教育</div>
              </div>
            </div>
            <div class="relative shadow w-56 h-64 bg-white" style="border-radius: 1.25rem">
              <div class="px-4">
                <img :src="baseOSSUrl + '/xuewei2.png'" class="text-indigo-500 w-12 h-12 my-10 inline-block" alt="">
                <div class="text-black text-lg font-medium">双学位</div>
                <div class="text-sm text-gray-400 mt-2 font-normal">外国大学的学位及认证+中国大学的学位</div>
              </div>
            </div>
            <div class="relative shadow w-56 h-64 bg-white" style="border-radius: 1.25rem">
              <div class="px-4">
                <img :src="baseOSSUrl + '/xuewei3.png'" class="text-indigo-500 w-12 h-12 my-10 inline-block" alt="">
                <div class="text-black text-lg font-medium">多语言教学</div>
                <div class="text-sm text-gray-400 mt-2 font-normal">沉浸式教育项目及课程，双语甚至三语校园，可以选择英语或中文或第三语言</div>
              </div>
            </div>
            <div class="relative shadow w-56 h-64 bg-white" style="border-radius: 1.25rem">
              <div class="px-4">
                <img :src="baseOSSUrl + '/xuewei4.png'" class="text-indigo-500 w-12 h-12 my-10 inline-block" alt="">
                <div class="text-black text-lg font-medium">招收高水平学生</div>
                <div class="text-sm text-gray-400 mt-2 font-normal">在成功案例的基础上实现规模化发展，招收一流水平的学生</div>
              </div>
            </div>
            <div class="relative shadow w-56 h-64 bg-white" style="border-radius: 1.25rem">
              <div class="px-4">
                <img :src="baseOSSUrl + '/xuewei5.png'" class="text-indigo-500 w-12 h-12 my-10 inline-block" alt="">
                <div class="text-black text-lg font-medium">优势结合</div>
                <div class="text-sm text-gray-400 mt-2 font-normal">在人才培养方面结合东西方教育优势</div>
              </div>
            </div>
          </div>
          <div class="grid gap-4 mx-auto sm:grid-cols-1 md:grid-cols-1 xl:grid-cols-2 justify-items-center text-center">
            <!--    左侧    -->
            <div class="relative proImg overflow-hidden shadow-lg hover:shadow-2xl" style="border-radius: 1.25rem;">
              <img class="object-cover proImg" :src="baseOSSUrl + '/xueyuan1.png'" alt="" />
              <div
                class="absolute inset-0 flex flex-col justify-center px-28 py-4 text-center transition-opacity duration-300 leftBg bg-opacity-75 opacity-0 hover:opacity-80">
                <img :src="baseOSSUrl + '/xueyuan3.png'" class="text-indigo-500 w-12 h-12 mt-10 mb-5 flex mx-auto"
                  alt="">
                <p class="text-lg font-bold textWhite relative borderLine">
                  大健康学院
                </p>
                <p class="mb-4 text-xs tracking-wide textWhite mt-3" style="letter-spacing:1px;">
                  公共卫生和老年护理方面的应用型职业培训，如养老护理人员。毕业生可选择在中国或国外从事医疗护理工作。
                </p>
              </div>
            </div>
            <!--    右侧          -->
            <div class="relative proImg overflow-hidden shadow-lg hover:shadow-2xl" style="border-radius: 1.25rem;">
              <img class="object-cover proImg" :src="baseOSSUrl + '/xueyuan2.png'" alt="" />
              <div
                class="absolute inset-0 flex flex-col justify-center px-28 py-4 text-center transition-opacity duration-300 rightBg bg-opacity-75 opacity-0 hover:opacity-80">
                <img :src="baseOSSUrl + '/xueyuan3.png'" class="text-indigo-500 w-12 h-12 mt-10 mb-5 flex mx-auto"
                  alt="">
                <p class="text-lg font-bold textWhite relative borderLine">
                  医学院
                </p>
                <p class="mb-4 text-xs tracking-wide textWhite mt-3" style="letter-spacing:1px;">
                  医学科研及临床医学教育，为临床医生、生物技术、转化医学、医疗设备、医学科研、生命科学和跨学科研究的研究人员和科学家提供教育和培养；具有国际化特色的本科和研究生课程及博士教育学位。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    baseOSSUrl
  } from '@/utils/oss';
  export default {
    name: "eduTabs",
    data() {
      return {
        baseOSSUrl,
        tabs: ["精彩直播", "认证教育", "学位教育"],
        active: 0,
        cont1: null,
        cont2: null,
        cont3: null,

        videoElement: [], // 创建一个数组
        options: {
          playbackRates: [0.75, 1.0, 1.5, 2.0], // 可选的播放速度
          autoplay: false, // 是否自动播放
          muted: false, // 是否静音 默认情况下将会消除任何音频
          loop: false, // 是否开启循环播放
          preload: "auto", // 自动预加载
          language: "zh-CN", // 语言，'en', 'zh-cn', 'zh-tw'
          aspectRatio: "16:9", // 播放器高宽占比（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          flash: {
            hls: {
              withCredentials: false
            }
          },
          html5: {
            hls: {
              withCredentials: false
            }
          },
          sources: [{
            type: "video/mp4", // 类型
            // src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4", // url地址
            src: baseOSSUrl + '/introduce.mp4'
          }],
          poster: "", // 封面地址
          width: document.documentElement.clientWidth,
          notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true, // 是否显示当前时间和持续时间的分隔符，"/"
            durationDisplay: true, // 是否显示持续时间
            remainingTimeDisplay: false, // 是否显示剩余时间
            fullscreenToggle: true, // 是否显示全屏按钮
          },
        },
      }
    },
    methods: {
      switchTab(index) { // 根据当前index切换到对应的页面内容
        if (index === 0) {
          this.active = 0;
          this.cont1.scrollIntoView({
            block: "start",
            behavior: "smooth"
          });
        } else if (index === 1) {
          this.active = 1;
          this.cont2.scrollIntoView({
            block: "start",
            behavior: "smooth"
          });
        } else {
          this.active = 2;
          this.cont3.scrollIntoView({
            block: "start",
            behavior: "smooth"
          });
        }
      },
      // 播放回调
      onPlayerPlay($event) {},
      // 暂停回调
      onPlayerPause($event) {},
      // 视频播完回调
      onPlayerEnded($event) {},
      // DOM元素上的readyState更改导致播放停止
      onPlayerWaiting($event) {},
      // 已开始播放回调
      onPlayerPlaying($event) {},
      // 当播放器在当前播放位置下载数据时触发
      onPlayerLoadeddata($event) {},
      // 当前播放位置发生变化时触发。
      onPlayerTimeupdate($event) {},
      //媒体的readyState为HAVE_FUTURE_DATA或更高
      onPlayerCanplay($event) {},
      //媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件。
      onPlayerCanplaythrough($event) {},
      //播放状态改变回调
      playerStateChanged($event) {},
      //将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
      playerReadied() {},
    },
    mounted() {
      this.cont1 = this.$refs["cont_1"];
      // this.cont2 = this.$refs["cont_2"];
      this.cont3 = this.$refs["cont_3"];
      const tabH = this.$refs["tab"].offsetHeight;
      // 添加scroll事件监听
      window.addEventListener("scroll", () => {
        if (this.cont3.getBoundingClientRect().top <= tabH) {
          this.active = 2;
          return false;
        }
        // if (this.cont2.getBoundingClientRect().top <= tabH) {
        //   this.active = 1;
        //   return false;
        // }
        if (this.cont1.getBoundingClientRect().top <= tabH) {
          this.active = 0;
        }
      });
      //视频初始化
      this.videoElement = document.getElementsByTagName('video-player') // 获取页面上所有的video对象

    },
    destroyed() {
      window.removeEventListener("scroll", () => {}, true)
    },
  }
</script>

<style scoped>
  .active {
    box-sizing: border-box;
    border-bottom-width: 2px;
    border-color: #123B7F;
  }

  .cont1 {
    background-color: #F1F4FB;
  }

  .cont2 {
    width: 100%;
  }

  .cont3 {
    background: #F1F4FB;
  }

  .proImg {
    width: 36.875rem;
    height: 29.8125rem;
  }

  .leftBg {
    background-color: #123B7F;
  }

  .rightBg {
    background-color: #C74238;
  }

  .textWhite {
    color: #FFFFFF;
  }

  .item::after {
    content: "";
    position: absolute;
    left: 14px;
    top: 0.4375rem;
    border: 1px solid #123B7F;
    background-color: #123B7F;
    display: inline-block;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    margin-right: 12px;
  }

  /* 超过5行文字就省略*/
  .newsIntroduceClass {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .borderLine:after {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 10%;
    bottom: -3px;
    height: 3px;
    border-radius: 3px;
    background-color: #FFFFFF;
    opacity: 0.2;
  }
</style>